export default __webpack_public_path__ + "static/media/slide1.eb4dff1c.jpg";